import { render, staticRenderFns } from "./SemanticUiNotification.vue?vue&type=template&id=78309a4f&"
import script from "./SemanticUiNotification.vue?vue&type=script&lang=js&"
export * from "./SemanticUiNotification.vue?vue&type=script&lang=js&"
import style0 from "./SemanticUiNotification.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports